// @dynamic-i18n-keys
// Dynamic t() at lines 66–74 (coreStatus: hasCore | noCore):
//   page.subscriptions.coreOnlyBlock.title.var.hasCore.updatedTiers
//   page.subscriptions.coreOnlyBlock.title.var.noCore.updatedTiers
//   page.subscriptions.coreOnlyBlock.subtitle.var.hasCore.updatedTiers
//   page.subscriptions.coreOnlyBlock.subtitle.var.noCore.updatedTiers
import type { FC } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiData, TierAddNewBiEvent } from '@wix/da-bi/pkg/events';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import TierCreatorReduxModule from '@wix/da-shared-react/pkg/Tier/redux/creator/ModuleLoadable';
import { useVerification } from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import EmptyState from '../../../EmptyState';

import s from './SubscriptionsCoreOnlyBlock.scss';

const SUBSCRIPTIONS_EMPTY_ILLUSTRATION_URL =
  'https://st.deviantart.net/eclipse/illustrations/subscriptions.png?1';

export interface Props {
  className?: string;
  createTier: () => void;
}

const SubscriptionsCoreOnlyBlock: FC<Props> = ({ className, createTier }) => {
  const { t } = useTranslation();

  // users who are gifted core can see these buttons even before they're verified
  const { restrictToVerified } = useVerification();
  const restrictedCreateTier = restrictToVerified('createsubscription', createTier);

  const tierBiData = BiData<TierAddNewBiEvent>({
    evid: 530,
    is_empty_state_view: 1,
    widgetname: undefined,
  });

  return (
    <div className={s['root']}>
      <TierCreatorReduxModule />
      <EmptyState
        className={c(s['empty-state-block'], s['new-empty-state'], className)}
        backgroundType="none"
        title={t('page.subscriptions.coreOnlyBlock.title.v2')}
        titleClassName={s['new-title']}
        subtitle={t('page.subscriptions.coreOnlyBlock.subtitle.v2')}
        subtitleClassName={s['new-subtitle']}
        illustration={
          <img
            src={SUBSCRIPTIONS_EMPTY_ILLUSTRATION_URL}
            alt=""
            className={s['new-illustration']}
          />
        }
        customButton={
          <BrandedButton
            className={s['button']}
            variant="brand-green"
            size="medium"
            onClick={restrictedCreateTier}
            biData={tierBiData}
          >
            {t('page.subscriptions.coreOnlyBlock.CTAbutton.createTier.v2')}
          </BrandedButton>
        }
      />
    </div>
  );
};
SubscriptionsCoreOnlyBlock.displayName = 'SubscriptionsCoreOnlyBlock';

export default SubscriptionsCoreOnlyBlock;
